let index = -1;

let inputs = document.querySelectorAll(".consent_inputs:not(.disabled-field), .gform_footer.before");
let widget = document.querySelector("#consent-widget");
let form = document.querySelector("#consent-form");
let certificate = document.querySelector("#consent-certificate");
let placeholder = document.querySelector("#consent-widget-placeholder");
let buttonUP = document.querySelector(".up");
let buttonMUP = document.querySelector(".m-up");
let buttonDOWN = document.querySelector(".down");
let buttonMDOWN = document.querySelector(".m-down");
let buttonSAVE = document.querySelector(".save");
let buttonMSAVE = document.querySelector(".m-save");
let buttonSUBMIT = document.querySelector(".gform_footer.before input[type='submit']");
if (!buttonSUBMIT) {
    buttonSUBMIT = document.querySelector(".gform_button.button input[type='submit']");
}
let helpBar = document.querySelector("#help-bar");
let backup = document.querySelectorAll(".gform_wrapper");

jQuery('div.help').on( 'click', function() {
    index++;
    if (placeholder) {
        placeholder.style.display = "none";
        widget.classList.remove("hidden");
        helpBar.classList.add("permanent");
        document.querySelector("#offer-help").classList.add("hidden");
        document.querySelector("#help-requested").classList.remove("hidden");
        buttonSAVE.style.visibility = "hidden";
        moveWidget();
        moveFocus();
        showHideButtons();
    }
});
jQuery('button.help').on( 'click', function() {
    index++;
    if (placeholder) {
        placeholder.style.display = "none";
        widget.classList.remove("hidden");
        helpBar.classList.add("permanent");
        document.querySelector("#offer-help").classList.add("hidden");
        document.querySelector("#help-requested").classList.remove("hidden");
        buttonSAVE.style.visibility = "hidden";
        moveWidget();
        moveFocus();
        showHideButtons();
    }
});


jQuery(document).ready(function() {
    if (widget) {
        widget.querySelector(".up").style.visibility = "hidden";
        $post_id = jQuery('#cf_pid').val();
        jQuery('input[type="hidden"][name="input_1"]').val($post_id);
        $role = jQuery('#cf_role').val();
        jQuery('input[type="hidden"][name="input_8"]').val($role);
        $aom = jQuery('#cf_aom').val();
        jQuery('input[type="hidden"][name="input_35"]').val($aom);
    }
});

jQuery('.up, .m-up').on('click', function () {
    index--;
    moveWidget();
    moveFocus();
    showHideButtons();
});

jQuery('.down, .m-down').on('click', function () {
    index++;
    moveWidget();
    moveFocus();
    showHideButtons();
});
jQuery('.save, .m-save').on( 'click', function() {
    index = 0;
    document.querySelector("html").appendChild(widget);
    if (!buttonSUBMIT) {
        buttonSUBMIT = document.querySelector("input.gform_button.button[type='submit']");
    }
    buttonSUBMIT.click();
});

function moveWidget() {
    if (inputs[index]) {
        inputs[index].scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        inputs[index].appendChild(widget);
    }
    //widget.classList.remove("initial");
    showHideButtons();
}
function moveFocus() {
    inputs[index].querySelector("input").focus({preventScroll: true});
}

function showHideButtons(){
    if (buttonUP) {
        buttonUP.style.visibility = "visible";
        buttonMUP.style.visibility = "visible";
        buttonDOWN.style.visibility = "visible";
        buttonMDOWN.style.visibility = "visible";
        buttonMDOWN.style.display = "block";
        buttonSAVE.style.visibility = "hidden";
        buttonMSAVE.style.visibility = "hidden";

        if (index === 0) {
            buttonUP.style.visibility = "hidden";
            buttonMUP.style.visibility = "hidden";
        }
        if (index === inputs.length - 2) {
            widget.classList.add("signature-consent");
        } else {
            widget.classList.remove("signature-consent");
        }
        if (index === inputs.length - 1) {
            widget.classList.add("save-consent");
            buttonDOWN.style.visibility = "hidden";
            buttonMDOWN.style.visibility = "hidden";
            buttonMDOWN.style.display = "none";
            buttonSAVE.style.visibility = "visible";
            buttonMSAVE.style.visibility = "visible";
        } else {
            widget.classList.remove("save-consent");
        }
    }
}

jQuery(document).on("gform_confirmation_loaded", function (e, form_id) {
    // Check if the form is a nested form
    if (form_id == 27) {
        // Skip the code if this is a nested form
        return;
    }

    // code to run upon successful form submission
    certificate.classList.remove("hidden");
    form.classList.add("hidden");
    certificate.scrollIntoView();
    if(widget) {
        widget.classList.add("hidden");
    }
});

jQuery(document).on("gform_post_render", function (e, form_id, current_page) {
    if( jQuery("div.gform_validation_errors").length !== 0 ){
        // code that should be run if the validation error exists goes here
        index = 0;
        inputs = document.querySelectorAll(".consent_inputs:not(.disabled-field), .gform_footer.before");
        if (placeholder) {
            placeholder.style.display = "none";
            moveWidget();
            moveFocus();
        }
    }
});

function consentAOMByProvince(provinceCode) {
    // Convert the province code to uppercase
    provinceCode = provinceCode.toUpperCase();

    // Age of majority mapping by province
    const ageOfMajority = {
        AB: 18, MB: 18, ON: 18, PE: 18, QC: 18, SK: 18,
        BC: 19, NB: 19, NL: 19, NS: 19, NT: 19, NU: 19, YT: 19,
    };

    // Return the age of majority for the given province code, defaulting to 18
    return ageOfMajority[provinceCode] || 18;

}